import {
  FETCH_SIEVE_SIZE_REQUEST,
  FETCH_SIEVE_SIZE_SUCCESS,
  FETCH_SIEVE_SIZE_FAILURE,
  ADD_SIEVE_SIZE_REQUEST,
  ADD_SIEVE_SIZE_SUCCESS,
  ADD_SIEVE_SIZE_FAILURE,
  UPDATE_SIEVE_SIZE_REQUEST,
  UPDATE_SIEVE_SIZE_SUCCESS,
  UPDATE_SIEVE_SIZE_FAILURE,
  DELETE_SIEVE_SIZE_REQUEST,
  DELETE_SIEVE_SIZE_SUCCESS,
  DELETE_SIEVE_SIZE_FAILURE,
  SIEVE_SIZE_FORM_ERROR,
  SIEVE_SIZE_FORM_SUCCESS,
  SET_SIEVE_SIZE_EDIT,
  CLEAR_SIEVE_SIZE_EDIT,
} from '../../../../types/masters/stoneAttribute/sieveSize/sieveSizeTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingSieveSize: null,
};

const sieveSizeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SIEVE_SIZE_REQUEST:
    case ADD_SIEVE_SIZE_REQUEST:
    case UPDATE_SIEVE_SIZE_REQUEST:
    case DELETE_SIEVE_SIZE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SIEVE_SIZE_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_SIEVE_SIZE_SUCCESS:
    case UPDATE_SIEVE_SIZE_SUCCESS:
    case DELETE_SIEVE_SIZE_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_SIEVE_SIZE_FAILURE:
    case ADD_SIEVE_SIZE_FAILURE:
    case UPDATE_SIEVE_SIZE_FAILURE:
    case DELETE_SIEVE_SIZE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_SIEVE_SIZE_EDIT:
      return { ...state, editingSieveSize: action.payload };
    case CLEAR_SIEVE_SIZE_EDIT:
      return { ...state, editingSieveSize: null };
    default:
      return state;
  }
};

export default sieveSizeReducer; 